<template>
  <div id="dashboard-page">
  </div>
</template>

<script>

export default {

};
</script>
<style scoped>
.el-table thead.is-group th {
  background: #f5f7fa;
  color: #444;
}
.filter-date-hidden {
  opacity: 0;
  position: absolute;
  cursor: pointer;
}


</style>